export default "__VITE_ASSET__C4jQueOa__"